import eventEmitter from '@/utils/emitter'

import { navigateToUrl } from '@shared/utils/navigate-to-url'

export function jumpToUrl(...args: Parameters<typeof navigateToUrl>) {
  const { hasJump, url } = navigateToUrl(...args)
  eventEmitter.$emit('sub-app-update-router-view', url)
  if (!hasJump) {
    eventEmitter.$emit('sub-app-push-route', url)
  }
}

export function openTypeToUrl(pathname: string, url: string) {
  if (window.location.pathname.includes(pathname)) {
    window.open(url, '_self')
  } else {
    window.open(url)
  }
}
